import React, { FC } from 'react';
import TableSimple from 'src/components/TableSimple';
import { ConstantsCodeType } from 'src/types/constantsCodes';
import { FileImportType, ClaimImportValidationErrorType } from 'src/types/claimsImport';
import { CustomRenderType, TableColumnType, TableRowType } from 'src/types/table';
import WarningIcon from '@mui/icons-material/Warning';
import CheckIcon from '@mui/icons-material/Check';
import Menu from 'src/components/Menu';
import translate from '@translate';
import Typography from 'src/components/Typography';
import { styled } from '@mui/system';
import { colors } from 'src/themes/default';
import { CLAIM_IMPORT_PREVIEW_COLUMNS } from './constants';

const WarningButton = styled('div')({
    '& svg path': {
        fill: colors.primary_O,
    },
});

export interface ValidationTableProps {
    claimStatusCodes: ConstantsCodeType[];
    currencyCodes: ConstantsCodeType[];
    files: FileImportType[];
}

const ValidationTable: FC<ValidationTableProps> = (props) => {
    const rows: TableRowType[] = [];
    props.files.forEach((file) => {
        file.validation?.forEach((row, index) => {
            rows.push({
                FCN: row.FCN,
                validationErrors: row.validationErrors,
                ...row.changes,
                id: `${file.file.name}-${index}`,
            });
        });
    });

    if (!rows.length) {
        return null;
    }

    const columns: TableColumnType[] = [
        {
            label: 'validity',
            key: 'validationErrors',
            customRender: true,
        },
        ...CLAIM_IMPORT_PREVIEW_COLUMNS,
    ];

    const customRender: CustomRenderType = (column, row) => {
        switch (column.key) {
            case 'validationErrors':
                if (row.validationErrors?.length) {
                    return (
                        <WarningButton>
                            <Menu
                                variant="menu"
                                itemStyle={{ borderBottom: '1px solid silver' }}
                                icon={<WarningIcon color="error" />}
                                items={(row.validationErrors as ClaimImportValidationErrorType[]).map((error) => (
                                    <div key={`${error.dataKey}-${error.label}`}>
                                        <span>{`${error.dataKey}: `}</span>
                                        <span>{translate(`error.${error.label}`, error)}</span>
                                    </div>
                                ))}
                            />
                        </WarningButton>
                    );
                }
                return <CheckIcon style={{ fill: 'green' }} />;
            default:
                return row[column.key];
        }
    };

    return (
        <>
            <Typography variant="h6" gutterBottom>
                {translate('claimsImport.previewTableTitle')}
            </Typography>
            <TableSimple
                rowIdKey="id"
                allColumns={columns}
                rows={rows}
                initSort={{ column: 'FCN', direction: 'ASC' }}
                columsLabelPrefix="claimsImport.table"
                selectOptions={{
                    claimStatusCodes: props.claimStatusCodes,
                    currencyCodes: props.currencyCodes,
                }}
                customRender={customRender}
            />
        </>
    );
};

export default ValidationTable;
